/**
 * Imports API
 */
import axios from 'axios';
import { API_URL } from '@/App.settings';

/**
 * Import stratégie
 */
import { SearchStrategy } from './SearchStrategy';

/**
 * Classes
 */
import BaseShortMeter from '@/types/BaseShortMeter';
import Dictionary from '@/types/Dictionary';

/**
 * Stratégie de recherche
 */
export class ShortMeterSearchStrategy extends SearchStrategy {

    protected override displayer = "ShortMeterSearchDisplayer";
    protected override event = "ShortMeterSelectedEvent";

    /**
     * Exécute l'appel API à 'FilterTree/SearchNode'.
     * @param parameters Les arguments nécessaires pour l'appel API (déjà formatés par le composant 'Search').
     * @returns Une promesse qui résout en un tableau de BaseNode.
     */
    protected async execute(parameters: Dictionary<any>): Promise<BaseShortMeter[]> {
        return new Promise((resolve, reject) => {
            console.debug("Search - ShortMeterSearchStrategy - parameters", parameters);
            axios.post(API_URL + 'FilterTree/SearchShortMeter', parameters).then((response) => {
                if (response && response.data) {
                    console.debug("Search - ShortMeterSearchStrategy - axiosResult", response.data);

                    const result = response.data.map(item => {
                        return new BaseShortMeter(item.Id, item.Name, item.Invariant, item.ObjectType, item.Location, item.IsDepreciated, item.Expendables, item.Version, item.Reference, item.InstallationDate, item.Color, item.Address, item.Provider, item.Contract, item.Tariff, item.SupplyPointNumber, item.RAEPCENumber, item.ContractNumber);
                    });

                    resolve(result);
                }
            });
        });
    }
}
